import { Autocomplete, TextField } from "@mui/material";
import { useGlobalContext } from "@root/context";
import { useCallback } from "react";
import { type Control, Controller, type UseFormSetValue } from "react-hook-form";
import { buildApproachesFromChallenges } from "../../logics/format";
import type { IModalActionForm, IModalActionResolver } from "../../logics/types";

export interface IModalActionFormApproachProps {
  control: Control<IModalActionForm, void, IModalActionResolver>;
  setFormValue: UseFormSetValue<IModalActionForm>;
}

export const ModalActionFormApproach = ({ control, setFormValue }: IModalActionFormApproachProps) => {
  const { challenges } = useGlobalContext();
  const approaches = buildApproachesFromChallenges(challenges);

  const getChallengeFromApproach = useCallback(
    (approach: string) => challenges.find((c) => c.approaches.some((a) => a._id === approach)),
    [challenges]
  );

  return (
    <Controller
      control={control}
      name="approach"
      render={({ field: { value, onChange }, fieldState: { error } }) => (
        <Autocomplete
          options={approaches}
          value={value}
          onChange={(_, value) => {
            if (value) {
              onChange({ _id: value._id, label: value.label, challengeName: value.challengeName });
              const challenge = getChallengeFromApproach(value._id);
              if (challenge) {
                setFormValue("challenges", [{ _id: challenge._id, name: challenge.name }]);
              }
            } else {
              onChange(null);
              setFormValue("challenges", []);
            }
          }}
          groupBy={(option) => option.challengeName}
          isOptionEqualToValue={(option, value) => option._id === value._id}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Type de démarche *"
              size="small"
              error={Boolean(error)}
              helperText={error?.message}
            />
          )}
        />
      )}
    />
  );
};
